var map,
	mapOptions,
	locationsObj = [],
	mapElement = document.querySelector('.map-container'),
	uri = window.location.href.split(body.id)[1],
	state = uri ? uri.split('/')[1] : 'all',
	isAll = state == 'all',
	locationsList = document.querySelector('.locations-list'),
	searchInput = document.getElementById('search-location-input'),
	closeLabel = document.querySelector('.close-locations-label'),
	apiKey = 'AIzaSyDDlhSqHk-iBcoPE_98cghilCfnZMg74PQ';
	hideFooter();
// Markers
var currentMarker,
	defaultPin = '/assets/images/icons/map-pin-pink'+(!isAll && !checkWidth(768) ? '-big' : '')+'.svg',
	currentPin = '/assets/images/icons/map-pin-current-pink'+(!isAll && !checkWidth(768) ? '-big' : '')+'.svg';

function hideFooter() {
	document.getElementById('footer').style.display = 'none';
}
function showFooter() {
	document.getElementById('footer').style.display = 'block';
}

if(mapElement) {
	window.initMap = function() {
		initMap(mapElement);
	};

	scriptWaypoint(mapElement, 'https://maps.googleapis.com/maps/api/js?key='+apiKey+'&callback=initMap&libraries=geometry,places', '110%');
}

function initMap() {
	// Autocomplete Search Box
	var searchOptions = {
			fields: ['formatted_address', 'geometry', 'name'],
			componentRestrictions : {country: 'us'}
		},
		searchBox = new google.maps.places.Autocomplete(searchInput, searchOptions);

	searchBox.addListener('place_changed', function() {
		getSearchURL();
	});

	axios.get('/map-section/'+state).then(function(r) {
		var locations = r.data.locations,
			center = JSON.parse('[38.0572718,-97.9475488]'); // Center of USA

		mapOptions = {
			zoom: isAll ? 5 : 7,
			streetViewControl: false, // hide the yellow Street View pegman
			scaleControl: true, // allow users to zoom the Google Map
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			center: new google.maps.LatLng(center[0], center[1]),
			styles: mapStyles
		};

		if(!r.data.state && !isAll) {
			filterLocations(locations);
		} else {
			buildMap(locations);
		}
		showFooter();
	});
}

function filterLocations(locations) {
	var geocoder = new google.maps.Geocoder();

 	geocoder.geocode({'address': searchInput.value}, function(results, status) {
		if(results) {
			var coords = results[0].geometry.location;

			locations.forEach(function(location, index) {
				var coordinates = JSON.parse('['+location.coordinates+']'),
					latLng = new google.maps.LatLng(coordinates[0], coordinates[1]);

				var distance = google.maps.geometry.spherical.computeDistanceBetween(latLng, coords) * 0.000621371192;

				if(distance <= 100) {
					location.distance = distance;
					location.html = location.html.replace('</span>', '</span><span class="distance">'+distance.toFixed(2)+' mi</span>');
				} else {
					delete locations[index];
				}
			});

			if(Object.keys(locations).length !== 0) {
				locations.sort((a, b) => {
					return a.distance - b.distance;
				});

				buildMap(locations);

				if(closeLabel && checkWidth(768)) {
					closeLabel.querySelector('span').innerHTML = Object.keys(locations).length;
					closeLabel.style.display = 'block';
				}
			} else {
				showNoLocationsMessage();
			}
		} else {
			showNoLocationsMessage();
		}
	});
}

function buildMap(locations) {
	var markers = [],
		bounds = new google.maps.LatLngBounds();

	map = new google.maps.Map(mapElement, mapOptions);

	let listContent = '';
	locations.forEach(function(location, index) {
		if(!isAll)
			listContent += location.html;
			// locationsList.innerHTML+= location.html;

		var coordinates = JSON.parse('['+location.coordinates+']'),
			latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
			selected = location.selected,
			marker = new google.maps.Marker({
				map: map,
				position: latLng,
				draggable: false,
				animation: google.maps.Animation.DROP,
				icon: selected ? currentPin : defaultPin
			});

		locationsObj.push({
			marker: marker,
			latLng: latLng
		});

		markers.push(marker);

		bounds.extend(marker.position);

		if(selected)
			currentMarker = marker;

		marker.addListener('click', function() {
			if(isAll) {
				window.location.href = location.url;
			} else {
				setMarker(index);
			}
		});
	});
	if(!isAll) {
		locationsList.innerHTML = listContent;
	}
	
	if(locations.length == 1) {
		map.setCenter(markers[0].getPosition());
		map.setZoom(15); 
	} else {
		map.fitBounds(bounds);
	}

	if(!isAll) {
		setCurrentLocationCard(false);

		[].slice.call(document.querySelectorAll('.location-card')).forEach(function(card, index) {
			card.addEventListener('click', function() {
				setMarker(index);
			});
		});

		document.querySelector('section.state-finder-map').classList.remove('hidden');
	}
}

function setMarker(index) {
	var card = document.querySelector('.location-card:nth-child('+(index+1)+')'),
		marker = locationsObj[index].marker,
		latLng = locationsObj[index].latLng;

	if(currentMarker)
		currentMarker.setIcon(defaultPin);

	if(currentMarker != marker) {
		marker.setIcon(currentPin);
		currentMarker = marker;
		setCurrentLocationCard(card);
		map.panTo(latLng);
	} else {
		currentMarker = false;
	}
}

function setCurrentLocationCard(card) {
	var currentCard = document.querySelector('.location-card.selected');

	if(card && card != currentCard) {
		if(currentCard)
			currentCard.classList.remove('selected');

		card.classList.add('selected');
		currentCard = card;
	}

	if(currentCard) {
		if(checkWidth(768))
			scrollToElement(mapElement);
		else
			locationsList.scrollTo({top: (currentCard.offsetTop - locationsList.offsetTop), behavior: 'smooth', duration: 750});
	}
}

// Location Search Form Submit
document.getElementById('search-location').addEventListener('submit', function(e) {
	e.preventDefault();

	getSearchURL();
});

function getSearchURL() {
	axios.get('/search-location/'+encodeURIComponent(searchInput.value)).then(function(r) {
		if(r.data.url)
			window.location.href = r.data.url;
	});
}

// Toggle View
[].slice.call(document.querySelectorAll(['#view-options button'])).forEach(function(button) {
	button.addEventListener('click', function() {
		var selected = document.querySelector('#view-options button[aria-selected="true"]');

		if(this != selected) {
			var isMap = this.classList.contains('map-view'),
				sibling = isMap ? this.nextElementSibling : this.previousElementSibling,
				animation = isMap ? 'slideDown' : 'slideUp',
				display = isMap ? 'block' : 'none';

			Velocity(mapElement, animation, {duration: 300, display: display});

			this.setAttribute('aria-selected', 'true');
			sibling.setAttribute('aria-selected', 'false');
		}
	});
});

function showNoLocationsMessage() {
	[].slice.call(document.querySelectorAll('section.simple_text.finder-text .filters-wrapper ~ *')).forEach(function(hidden) {
		hidden.style.display = 'block';
	});
}